/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Integrations_Mcp_Access_DescriptionInputs */



/**
* | output |
* | --- |
* | "Connect Claude, Cursor or another MCP client to oneAI. It works with your own permissions." |
*
* @param {My_Integrations_Mcp_Access_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_mcp_access_description = /** @type {((inputs?: My_Integrations_Mcp_Access_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_Mcp_Access_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbinden Sie Claude, Cursor oder einen anderen MCP-Client mit oneAI. Es gelten Ihre eigenen Berechtigungen.")
	return /** @type {LocalizedString} */ ("Connect Claude, Cursor or another MCP client to oneAI. It works with your own permissions.")
});